module.exports = __webpack_public_path__ + "img/组 18-3.185ab09e.png";